module.exports = __webpack_public_path__ + "img/9_38.412ddda4.png";